import DayOpeningHours from 'components/DayOpeningHours'

const Hours = ({
  hours,
  title,
  showValidationErrors,
  setValidationErrorsHours,
  validationErrorsHours,
  handleChangeHours,
}) => {
  return (
    <>
      <h3 className="header-title">{title}</h3>
      <p className="description">Time in 24-hour format</p>
      {Object.entries(hours)?.map(([day, hours]) => (
        <DayOpeningHours
          key={day}
          dayName={day}
          activeDay={!hours?.disabled ?? true}
          startTime={hours?.startTime}
          endTime={hours?.endTime}
          type={hours?.type}
          handleChange={handleChangeHours}
          showValidationErrors={showValidationErrors}
          setValidationErrorsHours={setValidationErrorsHours}
          validationErrorsHours={validationErrorsHours}
          dataCy={`${title} ${day}`}
        />
      ))}
    </>
  )
}

export default Hours
